import { createFileRoute, redirect } from "@tanstack/react-router"

import { TooManyRequests } from "#pages/login/too-many-requests.tsx"

export const Route = createFileRoute("/_auth/too-many-requests/")({
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({ to: "/" })
    }
  },
  component: TooManyRequests,
})
